import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../shared/useAuth.js';
import { BrandPanel } from './components/BrandPanel.jsx';
import { LoginForm } from './components/LoginForm.jsx';

export function Login() {
  const user = useAuth((s) => s.user);
  const ready = useAuth((s) => s.ready);
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && user) navigate('/dashboard', { replace: true });
  }, [ready, user, navigate]);

  if (ready && user) return <Navigate to="/dashboard" replace />;

  return (
    <div
      className="min-h-screen bg-paper grid"
      style={{ gridTemplateColumns: 'minmax(0,1fr) minmax(0,520px)' }}
    >
      <div className="hidden md:block">
        <BrandPanel />
      </div>
      <div className="flex items-center justify-center p-6 md:p-10">
        <LoginForm />
      </div>
    </div>
  );
}
